<template>
  <div class="message-pabel-box">
    <div v-if="nowSwitchId">
    <el-button class="eye-more" @click="eyeMore" v-if="isShowMore&&allPage!==page" type="text">加载更多消息
    </el-button>
    <el-button class="eye-more eye-more2" v-else type="text">没有更多消息
    </el-button>
    </div>
    <div class="nolist" v-else>
      可憐呀!沒有聊天对象
    </div>
    <!-- 大图预览 -->
    <el-image-viewer v-if="showBig" :on-close="closeViewer" :url-list="showBigImgList" />
    <ul class="message-styles-box">
      <li v-for="(item, index) in newMsglist" :key="index" v-show="item.url||item.msg_text"
        :class="judgeClass(item.from_id)">
        <img class="message-avatar" :src="avatar ? avatar : './static/img/Default-avatar.png'"
          v-if="item.from_id !== localInfo.sid">
        <img class="message-avatar" :src="localInfo.user_icon ? localInfo.user_icon : './static/img/Default-avatar.png'"
          v-else>
        <p class="message-nickname">{{formatTime(item.create_time)}}</p>
        <p class="message-classic" v-if="item.msg_type==='text'||item.msg_type==='help'">
          <span v-html="analysishtml(item.msg_text)"></span>
          <span class="yd" v-show="item.from_id === localInfo.sid" v-if="item.unread===1">已读</span>
          <span class="wd" v-show="item.from_id === localInfo.sid" v-else>未读</span>
        </p>
        <p class="message-classic" @click="showBigImg(item.url)" v-if="item.msg_type==='image'">
          <span class="picBox">
            <el-image :src="item.url" fit="fill" lazy></el-image>
          </span>
          <span class="yd" v-show="item.from_id === localInfo.sid" v-if="item.unread===1">已读</span>
          <span class="wd" v-show="item.from_id === localInfo.sid" v-else>未读</span>
        </p>
        <p class="message-classic" v-if="item.msg_type==='prodUrl'" @click="toProduct(item.msg_text)">
          <span class="productBox">
            <div class="pic" v-html="loadPic(item.msg_text)"></div>
            <div class="text" v-html="loadPname(item.msg_text)"></div>
          </span>
          <span class="yd" v-show="item.from_id === localInfo.sid" v-if="item.unread===1">已读</span>
          <span class="wd" v-show="item.from_id === localInfo.sid" v-else>未读</span>
        </p>
        <p class="message-classic" v-if="item.msg_type==='file'" @click="toOpenUrl(item.url)">
          <span class="productBox">
            <div class="pic pic2">
              <img src="../assets/img/file.png" />
            </div>
            <div class="text text2">
              {{item.file_name}}
              （<span v-html="formatSize(item.file_size)"></span>）
            </div>
          </span>
          <span class="yd" v-show="item.from_id === localInfo.sid" v-if="item.unread===1">已读</span>
          <span class="wd" v-show="item.from_id === localInfo.sid" v-else>未读</span>
        </p>
        <p class="message-classic" v-if="item.msg_type==='transed'">
          <span class="productBox">
            <div class="pic">
              <img :src="item.trans_targe_avatar? item.trans_targe_avatar : './static/img/Default-avatar.png'" />
            </div>
            <div class="text">
              {{item.trans_targe_name}}{{item.trans_title_msg}}
            </div>
          </span>
          <span class="yd" v-show="item.from_id === localInfo.sid" v-if="item.unread===1">已读</span>
          <span class="wd" v-show="item.from_id === localInfo.sid" v-else>未读</span>
        </p>
      </li>
      <li class="message-layout-right" v-show="isSending"><img :src="localInfo.user_icon ? localInfo.user_icon : './static/img/Default-avatar.png'"
          class="message-avatar">
        <p class="message-classic">发送中...</p>
      </li>
    </ul>
  </div>


</template>

<script>
  import Bus from '@/assets/eventBus'
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  // 导入组件
  import {
    gotoBottom
  } from '@/assets/tools'
  import {
    getlistMsg
  } from '@/api/customer'
import { set } from 'shelljs'
  export default {
    name: 'MessagePabel',
    components: {
      ElImageViewer
    },
    props: {
      // 选择的联系人ID
      nowSwitchId: {
        type: String
      },
      reload:{
        type:Boolean
      },
      // 选择的联系人头像
      avatar: {
        type: String
      },
      // 当前用户
      localInfo: {
        type: Object
      },
      // 收到信息
      newMsgs: {
        type: String
      },
      isRead: {
        type: Boolean
      }
    },
    data() {
      return {
        message: {},
        page: 1,
        allPage: 0,
        isShowMore: true,
        newMsglist: [],
        gotoBottom: gotoBottom,
        showBig: false,
        showBigImgList: [],
        isSending:false,
        sendStatus:false,
        timeOut:null
      }
    },
    watch: {
      // 被侦听的变量count
      nowSwitchId() {
        console.log('count 发生了变化' + this.nowSwitchId);
        this.page = 1;
        this.loadMsgList();
      },
      reload(){
        console.log('重新加载');
        this.page = 1;
        this.loadMsgList();
      },
      //收到信息
      newMsgs() {
        console.log('新消息' + this.newMsgs);
        let that = this;
        let newMsg = JSON.parse(this.newMsgs);
        this.showMsg(newMsg);
        this.sendStatus=false;
        clearTimeout(this.timeOut);
        this.timeOut=null
      },
      //更新已读
      isRead() {
        console.log('设为已读' + this.isRead);
        for (let i in this.newMsglist) {
          this.newMsglist[i].unread = 1;
          // this.isRead=false;
        }
      }
    },
    created() {
      this.loadMsgList();
    },
    beforeDestroy() {
      Bus.$off('MESSAGE')
    },
    mounted() {
      /**
       * 当前用户发的消息
       */
      let that=this;
      Bus.$on('MESSAGE', response => {
        console.log('把消息传给父级' + JSON.stringify(response));
        if(response.isImg){
            this.isSending=response.loading;
        }
        if(response.isText){
         this.timeOut= setTimeout(()=>{
             that.isSending=false
             that.$message.error('消息发送失败')
          },3000)
        }

        // this.showMsg(response);
        // 把消息传给父级
        // this.$emit('message', response)
      })
    },
    methods: {
      /**
       * 数组初始化
       */
      //获取聊天信息
      loadMsgList() {
        let that = this;
        let obj = {
          page: this.page,
          rows: '',
          oneUserId: this.nowSwitchId,
          twoUserId: this.$store.state.custId //自己
        };
        getlistMsg(obj).then(res => {
          if (res.rows) {
            let list = res.rows.reverse();
            res.totalPage <= 1 ? this.isShowMore = false : this.isShowMore = true
            if (this.page === 1) {
              this.newMsglist = list;
              this.allPage = res.totalPage;
              this.tobottom();
            } else {
              this.newMsglist = list.concat(this.newMsglist);
            }
          }
        })
      },
      //图片放大功能
      showBigImg(url) {
        this.showBig = true;
        this.showBigImgList = [url]
      },
      closeViewer() {
        this.showBig = false;
      },
      /**
       * 判断Class
       */
      judgeClass(type) {
        if (type !== this.localInfo.sid) {
          return 'message-layout-left'
        } else {
          return 'message-layout-right'
        }
      },

      /**
       * 查看更多
       */
      eyeMore() {
        this.page += 1
        this.loadMsgList();
        // 发送查询消息
        // this.$socket.emit('QUERY_PAGE', obj)
      },
      showMsg(newMsg){
        let msg = {
          from_id: newMsg.from_id,
          create_time: newMsg.msg_ctime,
          msg_type: newMsg.msg_type,
          msg_text: newMsg.message,
          url: newMsg.media_url || '',
          unread: newMsg.unread
        }
        this.newMsglist.push(msg);
        this.tobottom();
      },
      /**
       * 获取年月日
       */
      formatFullYearMonthDay(date, isShowHourMinute, type) {
        date = new Date(date)
        const fullYear = date.getFullYear()
        const month = date.getMonth() + 1
        let dayDate = date.getDate()
        var hours = date.getHours()
        var minutes = date.getMinutes()
        dayDate = dayDate < 10 ? `0${dayDate}` : dayDate
        if (isShowHourMinute) {
          return `${fullYear}${month}${dayDate}${hours}${minutes}`
        } else {
          if (type) {
            return `${fullYear}${type}${month}${type}${dayDate}`
          } else {
            return `${fullYear}${month}${dayDate}`
          }
        }
      },
      /**
       * 时间格式化
       */
      formatTime(time) {
        var date = new Date(time)
        var nowDate = new Date().getTime();
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var seconds = date.getSeconds()
        hours = hours < 10 ? `0${hours}` : hours
        minutes = minutes < 10 ? `0${minutes}` : minutes
        seconds = seconds < 10 ? `0${seconds}` : seconds
        if (this.formatFullYearMonthDay(date) === this.formatFullYearMonthDay(nowDate)) {
          return `${hours}:${minutes}:${seconds}`
        } else {
          return `${this.formatFullYearMonthDay(date, false, '-')} ${hours}:${minutes}:${seconds}`
        }
      },
      //产品图片
      loadPic(obj) {
        let t = obj.replace('\\', '');
        let text = JSON.parse(t);
        let img = '<img style="width:80px;" src=' + text.product_pic + '>';
        return img;
      },
      //产品名称
      loadPname(obj) {
        let t = obj.replace('\\', '');
        let text = JSON.parse(t);
        let name = text.product_name;
        return name;
      },
      //打开产品链接
      toProduct(obj) {
        let t = obj.replace('\\', '');
        let text = JSON.parse(t);
        let url = text.product_url;
        window.open(url, '_blank');
      },
      //打开文件
      toOpenUrl(url) {
        window.open(url, '_blank');
      },
      //计算大小
      formatSize(size) {
        let tempSize = (parseFloat(size)) / (1024);
        let sizeStr = '';
        console.log("---tempSize---" + tempSize);
        if (tempSize >= 0 && tempSize < 1024) {
          tempSize = Math.floor(tempSize * 100) / 100;
          sizeStr = tempSize.toFixed(2) + "KB";
        } else {
          tempSize = Math.floor(tempSize * 100) / 100;
          sizeStr = (tempSize / 1024).toFixed(2) + "MB";
        }
        return sizeStr;
      },
      //历史记录
      analysishtml(obj) {
        let value = '';
        let face = obj.toString();
        if (face && face.indexOf('[face-') > -1) {
          value = face.replace('[face-', "");
          value = value.replace(']', "");
          value = '<img class="pic3" style="max-width:100px" src="' + value + '">';
          return value;
        } else {
          return this.html_encode(face);
        }
      },
      //转译特殊符号
      html_encode(str) {
        let s = "";
        if (str && str.length == 0) return "";
        s = str.replace(/&/g, "&gt;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/ /g, "&nbsp;");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");
        s = s.replace(/\n/g, "<br>");
        return s;
      },
      //消息至底
      tobottom() {
        let that = this;
        setTimeout(() => {
          that.gotoBottom();
        }, 100)
      }
    }
  }
</script>

<style>
  ul {
    margin: 0;
    padding: 0;
  }

  ul li {
    list-style: none;
  }

  .message-pabel-box {
    padding: 0 20px;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: rgba(255, 255, 255, 0.8);
  }

  .message-pabel-box .eye-more {
    width: 100%;
    padding: 10px 0;
    font-size: 12px;
    text-align: center;
  }

  .message-pabel-box .eye-more2 {
    color: #999;
  }

  .message-pabel-box .message-styles-box {
    margin-bottom: 20px;
    padding-bottom: 150px;
  }

  .message-pabel-box .message-styles-box .message-layout-left,
  .message-pabel-box .message-styles-box .message-layout-right {
    margin-top: 40px;
    width: 100%;
    position: relative;
  }

  .message-pabel-box .message-styles-box .message-layout-left .message-classic::before,
  .message-pabel-box .message-styles-box .message-layout-right .message-classic::before {
    content: '';
    position: absolute;
    border-width: 8px;
    border-style: solid;
  }

  .message-pabel-box .message-styles-box .message-layout-left .message-avatar {
    float: left;
    margin-right: 10px;
    margin-top: 0px;
  }

  .message-pabel-box .message-styles-box .message-layout-left .message-classic {
    background-color: #F5F7FA;
    position: relative;
  }

  .message-pabel-box .message-styles-box .message-layout-left .message-classic::before {
    left: -16px;
    border-color: transparent rgba(255, 255, 255, 0.8) transparent transparent;
  }

  .message-pabel-box .message-styles-box .message-layout-right {
    text-align: right;
  }

  .message-pabel-box .message-styles-box .message-layout-right .message-avatar {
    float: right;
    margin-left: 10px;
  }

  .message-pabel-box .message-styles-box .message-layout-right .message-classic {
    text-align: left;
    color: #333;
    background-color: #DAECFF;
    border-radius: 10px 0 10px 10px;
  }
  .nolist{
    line-height: 200px;
    text-align:center;
    color:#999;
    font-size: 12px;
  }
  .message-pabel-box .message-styles-box .message-layout-right .message-classic::before {
    left: -16px;
    border-color: transparent rgba(255, 255, 255, 0.8) transparent transparent;
  }

  .message-pabel-box .message-styles-box .message-layout-right .message-classic .yd {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -10px;
    margin-left: -36px;
    color: #CCCCCC;
  }

  .message-pabel-box .message-styles-box .message-layout-right .message-classic .wd {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -10px;
    margin-left: -36px;
    color: #409EFF;
  }

  .message-pabel-box .message-styles-box .message-avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }

  .message-pabel-box .message-styles-box .message-nickname {
    width: 100%;
    color: #777777;
    font-size: 12px;
    text-align: center;
    color: #BFC3CF;
    position: absolute;
    top: -20px;
    left: 0;
  }

  .message-pabel-box .message-styles-box .message-classic {
    position: relative;
    max-width: 45%;
    margin-top: 0px;
    display: inline-block;
    padding: 12px 12px;
    font-size: 14px;
    color: #333333;
    border-radius: 0px 10px 10px 10px;
    white-space: pre-line;
    word-break: break-all;
    min-height: 20px;
  }

  .message-pabel-box .message-styles-box .message-classic img {
    vertical-align: top;
  }

  .message-pabel-box .message-styles-box .message-classic .picBox img {
    max-width: 100%;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox {
    width: 220px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    cursor: pointer;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox .pic {
    width: 80px;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox .pic img {
    width: 100%;
    height: 80px;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox .pic2 {
    width: 60px;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox .pic2 img {
    width: 100%;
    height: 60px;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox .text {
    height: 54px;
    line-height: 18px;
    overflow: hidden;
    color: #888;
    width: 130px;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .message-pabel-box .message-styles-box .message-classic .productBox .text2 {
    width: 150px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #F5F5F5;
  }

  /*定义滚动条轨道
   内阴影+圆角*/
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  /*定义滑块
   内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/message-pabel.vue